class GuardarPrecioPss{
    IdPrestador= 0
    CodMetasalud= "" 
    PrecioPss= 0
}

export default GuardarPrecioPss